module.exports = "<div class=\"mb\" base-container ng-transclude>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/base/components/container/container.template.html
// module id = 203
// module chunks = 0